


















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { albumUploadMapper } from '@/store/modules/albumUpload';
import { AlbumUpload } from '@/types/albumUpload';
import { player } from '@/components/music-player/Player.vue';

@Component<AlbumUploadDock>({
  computed: {
    ...albumUploadMapper.mapGetters(['visibleUploads', 'hasVisible'])
  },
  methods: {
    ...albumUploadMapper.mapActions(['startPolling', 'stopPolling', 'dismiss', 'retry', 'remove'])
  }
})
export default class AlbumUploadDock extends Vue {
  public visibleUploads!: AlbumUpload[];
  public hasVisible!: boolean;
  public startPolling!: () => void;
  public stopPolling!: () => void;
  public dismiss!: (id: number) => void;
  public retry!: (id: number) => Promise<void>;
  public remove!: (id: number) => Promise<void>;

  public collapsed = false;
  public actingId: number | null = null;

  // Когда открыт плеер (фиксированная полоса внизу) — поднимаем док над ним,
  // иначе прижимаем к низу.
  get dockStyle() {
    return { bottom: player.playingTrack ? '96px' : '20px' };
  }

  mounted() {
    this.startPolling();
  }

  beforeDestroy() {
    this.stopPolling();
  }

  get summary(): string {
    const processing = this.visibleUploads.filter(u => u.status === 'processing').length;
    const error = this.visibleUploads.filter(u => u.status === 'error').length;
    const done = this.visibleUploads.filter(u => u.status === 'done').length;

    const parts: string[] = [];
    if (processing) {
      parts.push(`${processing} в обработке`);
    }
    if (error) {
      parts.push(`${error} с ошибкой`);
    }
    if (done) {
      parts.push(`${done} готово`);
    }

    return parts.join(' · ');
  }

  public doneCount(upload: AlbumUpload): number {
    return upload.tracks.filter(t => t.status === 'done').length;
  }

  public progress(upload: AlbumUpload): number {
    if (upload.tracks.length === 0) {
      return 0;
    }
    return Math.round((this.doneCount(upload) / upload.tracks.length) * 100);
  }

  public openUpload(id: number) {
    if (Number(this.$route.params.id) === id && this.$route.name === 'albumUploadProgress') {
      return;
    }
    this.$router.push({ name: 'albumUploadProgress', params: { id: String(id) } });
  }

  public async onRetry(id: number) {
    this.actingId = id;
    try {
      await this.retry(id);
    } finally {
      this.actingId = null;
    }
  }

  public async onRemove(id: number) {
    this.actingId = id;
    try {
      await this.remove(id);
    } finally {
      this.actingId = null;
    }
  }
}
